import type { BoxProps } from './Box';
import { Box, getBoxProps } from './Box';

type Props = BoxProps & {
  src: string;
  alt: string;
};

const ImageLegacy = ({
  src,
  alt,
  className,
  width,
  height,
  ...props
}: Props) => (
  <Box
    as="img"
    src={src}
    alt={alt}
    className={className}
    width={width}
    height={height}
    {...getBoxProps(props)}
  />
);

export { ImageLegacy };
